// Wedding-invitation frame: cream→sand gradient background with a double-rule
// gold border. Pure chrome — no behavior. Children render in a centered z-10
// column above the border so the gold rule is visible on all four sides.
export default function GoldFrame({ children, className = '' }) {
  return (
    <div
      className={`relative mx-auto w-full max-w-[680px] overflow-hidden rounded-sm bg-cream-gradient shadow-[0_30px_60px_-30px_rgba(47,42,38,0.18)] ${className}`}
    >
      {/* Inner double-rule gold border. */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-3 border border-gold/70"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-4 border border-gold/35"
      />
      {/* Paper grain overlay: SVG turbulence at 6% opacity, multiply blend. */}
      <svg
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 z-0 h-full w-full opacity-[0.06] mix-blend-multiply"
      >
        <filter id="boda-grain">
          <feTurbulence baseFrequency="0.9" numOctaves="2" stitchTiles="stitch" />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#boda-grain)" />
      </svg>

      <div className="relative z-10 px-6 py-10 sm:px-10 sm:py-14">{children}</div>
    </div>
  );
}
